// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";
import NewsThemeLinkFormSection from "./NewsThemeLinkFormSection";
import { NewsThemeFormProps } from "../../../types/NewsThemeTypes";
import { LINKS_NUMBER_BY_NEWS_THEME } from "../../../../utils/Constant";
import { Divider } from "antd";
import { useTranslation } from "react-i18next";

const NewsThemeLinksFormSection: React.FunctionComponent<NewsThemeFormProps> = (
  props: NewsThemeFormProps
) => {
  const { t } = useTranslation();
  const { editMode } = props;
  return (
    <>
      {[...Array(LINKS_NUMBER_BY_NEWS_THEME)].map((x, i) => (
        <React.Fragment key={i}>
          <Divider orientation="left">
            <h3 className="text-secondary mb-0">
              {t("news_theme.links")} {i + 1}
            </h3>
          </Divider>
          <NewsThemeLinkFormSection key={i} index={i} editMode={editMode} />
        </React.Fragment>
      ))}
    </>
  );
};

NewsThemeLinksFormSection.defaultProps = {
  editMode: true
};

export default NewsThemeLinksFormSection;
